/**
* Rating Star Descriptors
* @module ratingStarDescriptors
* @description Displays text describing what each star rating means when rating an order.
*/

import $ from 'qwery';
import debounce from 'lodash.debounce';

let selectedDescriptor;

/**
 * Update element with our selected descriptor data.
 *
 * @param {HTMLElement} element
 * @param {object} descriptor
 */
function setDescriptor (element, descriptor) {
    element.textContent = descriptor;
}

/**
 * Sets the descriptor then stores it as the selected descriptor
 *
 * @param {HTMLElement} element
 */
function selectDescriptor (element) {
    const descriptorElem = getAssociatedDescriptor(element);
    const descriptor = getDescriptorToApply(element);

    selectedDescriptor = descriptor;
    setDescriptor(descriptorElem, selectedDescriptor);
}

/**
 * Return element we will be using to show the star descriptor label copy.
 *
 * @param {HTMLElement} element
 */
function getAssociatedDescriptor (element) {
    const ratingControl = element.closest('.ratingGroup');
    return $('.reviewSubmission-ratingDescriptor', ratingControl)[0];
}

/**
 * Return Object of the rating value, and the text colour used for styling.
 *
 * @param {HTMLElement} element
 *
 * @returns {object}
 */
function getDescriptorToApply (element) {
    return element.getAttribute('data-text');
}

/**
 * @param {MouseEvent} event
 */
function onStarClick (event) {
    selectDescriptor(event.target);
}

/**
 * @param {MouseEvent} event
 */
function onStarMouseOver (event) {
    const descriptorElem = getAssociatedDescriptor(event.target);
    const descriptor = getDescriptorToApply(event.target);

    // Save the current state
    selectedDescriptor = descriptorElem.textContent;

    setDescriptor(descriptorElem, descriptor);
}

/**
 * @param {MouseEvent} event
 */
function onStarMouseOut (event) {
    const descriptorElem = getAssociatedDescriptor(event.target);

    // Set back to the initial state
    setDescriptor(descriptorElem, selectedDescriptor);
}

function bindStarEvents (star) {
    star.addEventListener('click', debounce(onStarClick, 50));
    star.addEventListener('mouseover', debounce(onStarMouseOver, 50));
    star.addEventListener('mouseout', debounce(onStarMouseOut, 50));
}

function starActions (star) {
    bindStarEvents(star);

    // Cater for cached page reload in Firefox where the selected stars aren't cleared
    const radioId = star.getAttribute('for');
    const radio = document.getElementById(radioId);

    if (radio.checked) {
        selectDescriptor(star);
    }
}

function setup () {

    if ($('.reviewSubmission-ratingDescriptor.unrated').length > 0) {
        const ratingStars = $('.ratingControl-stars');

        if (ratingStars.length > 0) {
            ratingStars.forEach(starActions);
        }
    }

}

setup();

export {
    setup
};
